import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CreateFaqFailureAction,
  CreateFaqRequestAction,
  CreateFaqSuccessAction,
  DeleteFaqFailAction,
  DeleteFaqRequestAction,
  DeleteFaqSuccessAction,
  FaqActions,
  FetchFaqFailureAction,
  FetchFaqRequestAction,
  FetchFaqSuccessAction,
  ResetFaq,
  stateStatusType,
  UpdateFaqFailAction,
  UpdateFaqRequestAction,
  UpdateFaqSuccessAction,
} from "./actionType";
import { FaqState, initialState } from "./state";

// fetch faq
const fetchFaqRequest = (
  state: FaqState,
  action:FetchFaqRequestAction
) => {
  return updateObject(state, {
    fetchFaqState: {
      ...state.fetchFaqState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchFaqSuccess = (
  state: FaqState,
  action:FetchFaqSuccessAction
) => {
  return updateObject(state, {
    fetchFaqState: {
      ...state.fetchFaqState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      faq: action.payload,
    },
  });
};

const fetchFaqFail = (
  state: FaqState,
  action:FetchFaqFailureAction
) => {
  return updateObject(state, {
    fetchFaqState: {
      ...state.fetchFaqState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      roles: null,
    },
  });
};

//create Faq
const createFaqRequest = (
  state: FaqState,
  action: CreateFaqRequestAction
) => {
  return updateObject(state, {
    genericFaqState: {
      ...state.genericFaqState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const createFaqSuccess = (
  state: FaqState,
  action: CreateFaqSuccessAction
) => {
  const existingFaq = state.fetchFaqState.faq ?? [];
  return updateObject(state, {
    genericFaqState: {
      ...state.genericFaqState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchFaqState: {
      ...state.fetchFaqState,
      faq: [...existingFaq, action.payload],
    },
  });
};

const createFaqFail = (
  state: FaqState,
  action: CreateFaqFailureAction
) => {
  return updateObject(state, {
    genericFaqState: {
      ...state.genericFaqState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchFaqState: {
      ...state.fetchFaqState,
      isLoading: false,
    },
  });
};
//update Faq
const updateFaqRequest = (
  state: FaqState,
  action: UpdateFaqRequestAction
) => {
  return updateObject(state, {
    genericFaqState: {
      ...state.genericFaqState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const updateFaqSuccess = (
  state: FaqState,
  action: UpdateFaqSuccessAction
) => {
 const newFaq =
    state.fetchFaqState?.faq?.map((item) =>
      item.id === action.payload.id ? action.payload : item
    ) ?? [];
  return updateObject(state, {
    genericFaqState: {
      ...state.genericFaqState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchFaqState: {
      ...state.fetchFaqState,
      faq: [...newFaq],
    },
  });
};

const updateFaqFail = (
  state: FaqState,
  action: UpdateFaqFailAction
) => {
  return updateObject(state, {
    genericFaqState: {
      ...state.genericFaqState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchFaqState: {
      ...state.fetchFaqState,
      isLoading: false,
    },
  });
};
//delete Faq
const deleteFaqRequest = (
  state: FaqState,
  action: DeleteFaqRequestAction
) => {
  return updateObject(state, {
    genericFaqState: {
      ...state.genericFaqState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const deleteFaqSuccess = (
  state: FaqState,
  action: DeleteFaqSuccessAction
) => {
 const faq = state.fetchFaqState?.faq ?? [];
  const newFaq = faq.filter((item) => item.id !== action.payload);
  return updateObject(state, {
    genericFaqState: {
      ...state.genericFaqState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchFaqState: {
      ...state.fetchFaqState,
      faq: [...newFaq],
    },
  });
};

const deleteFaqFail = (
  state: FaqState,
  action: DeleteFaqFailAction
) => {
  return updateObject(state, {
    genericFaqState: {
      ...state.genericFaqState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchFaqState: {
      ...state.fetchFaqState,
      isLoading: false,
    },
  });
};
const recreateFaq = (state: FaqState, action: ResetFaq) => ({
  ...state,
  genericFaqState: { ...initialState.genericFaqState },
});

const fetchFaq = (state = initialState, action: FaqActions) => {
  switch (action.type) {
    case actionTypes.FETCH_FAQ_REQUEST:
      return fetchFaqRequest(state, action);
    case actionTypes.FETCH_FAQ_SUCCESS:
      return fetchFaqSuccess(state, action);
    case actionTypes.FETCH_FAQ_FAIL:
      return fetchFaqFail(state, action);
    case actionTypes.CREATE_FAQ_REQUEST:
      return createFaqRequest(state, action);
    case actionTypes.CREATE_FAQ_SUCCESS:
      return createFaqSuccess(state, action);
    case actionTypes.CREATE_FAQ_FAIL:
      return createFaqFail(state, action);
    case actionTypes.UPDATE_FAQ_REQUEST:
      return updateFaqRequest(state, action);
    case actionTypes.UPDATE_FAQ_SUCCESS:
      return updateFaqSuccess(state, action);
    case actionTypes.UPDATE_FAQ_FAIL:
      return updateFaqFail(state, action);
    case actionTypes.DELETE_FAQ_REQUEST:
      return deleteFaqRequest(state, action);
    case actionTypes.DELETE_FAQ_SUCCESS:
      return deleteFaqSuccess(state, action);
    case actionTypes.DELETE_FAQ_FAIL:
      return deleteFaqFail(state, action);
    case actionTypes.RESET_FAQ:
      return recreateFaq(state, action);
    default:
      return state;
  }
};

export default fetchFaq;
